export default "__VITE_ASSET__DcKmLzBJ__"